<template>
  <user-manager 
    v-bind:canEdit="false"
    v-bind:context="'kiosk-manager'"
    v-bind:functionalRoles="functionalRoles"
    v-bind:toolbarColor="appColor_GenieLight"
    v-bind:toolbarColorDark="appColor_Genie"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import UserManager from '@/components/UserManager'
import { AppColor } from '@/config.js'

export default {
  name: "GenieKioskManagers",
  components: {
    UserManager
  },
  data() {
    return {
      appColor_GenieLight: AppColor.KioskTypeGenieLight,
      appColor_Genie: AppColor.KioskTypeGenie
    }
  },
  computed: {
    ...mapGetters (['isAdmin', 'isDomainManager']),
    functionalRoles () {
      const roles = [
        this.getExpression('FunctionalRole', 'KioskManager')
      ]
      if (this.isDomainManager || this.isAdmin) {
        roles.push(this.getExpression('FunctionalRole', 'DomainManager'))
      }
      return roles
    }
  }
}
</script>